module.exports = __webpack_public_path__ + "static/media/logo.097ed29f.png";